// The channel resolution logic is shared with the standalone Contact Channels
// block. It lives in common/ so both the layout modal and the block import the
// same single source of truth.
export {
  resolveChannels,
  type ResolvedChannel,
  type ChannelType,
  type ChannelsHost,
} from "../../common/contactChannels"
